import React, { useState, useEffect } from 'react';
import { getSignupData, setSignupData } from './utils/localStorage';
import { signup } from './api';
import { validateSignupData } from './utils/validation';

import { 
    GlobalStyle, 
    Topbar,
} from './styled';

import UserForm from './components/User';
import PasswordForm from './components/Password';
import Loading from './components/Loading';
import ErrorMessage from './components/ErrorMessage';
import MobileMessage from './components/MobileMessage';
import MaintenanceMessage from './components/MaintenanceMessage';

// Cadastro self-service pausado: o time comercial faz o cadastro pelo WhatsApp.
// Volte para false quando o checkout/contratação online estiver pronto.
const SIGNUP_MAINTENANCE = true;

const initialSignupData = getSignupData();

const Onboarding = () => {
    const [signupData, setSignupDataState] = useState(initialSignupData);
    const [progress, setProgress] = useState(30);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const [isMobile, setIsMobile] = useState(false);
    const [showMobileMessage, setShowMobileMessage] = useState(false);

    const updateSignupData = (data) => {
        setSignupData(data);
        setSignupDataState(data);
        setValidationErrors({});
    };

    useEffect(() => {
        if (progress === 100) {
            handleSignup();
        }
    }, [progress]);

    useEffect(() => {
        setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    }, []);

    const handleSignup = async () => {
        try {
            // Validate the data before making the API call
            const { isValid, errors } = validateSignupData(signupData);
            
            if (!isValid) {
                setValidationErrors(errors);
                setProgress(30); // Go back to the first step
                return;
            }

            const response = await signup(signupData);
            console.log('Signup successful:', response);
            if (isMobile) {
                setShowMobileMessage(true);
            } else {
                window.location.href = response.redirect_to;
            }
        } catch (error) {
            console.error('There was an error signing up!', error);
            if (error.name === 'SignupError') {
                setError(error.message);
            } else {
                setError('Não foi possível completar o cadastro. Por favor, tente novamente mais tarde.');
            }
        }
    };

    const handleRetry = () => {
        setError(null);
        setValidationErrors({});
        setProgress(30);
    };

    if (SIGNUP_MAINTENANCE) {
        return (
            <>
                <GlobalStyle />
                <Topbar progress={0} />
                <MaintenanceMessage />
            </>
        );
    }

    return (
        <>
            <GlobalStyle />
            <Topbar progress={progress} />
            {error && <ErrorMessage message={error} onRetry={handleRetry} />}
            {!error && !showMobileMessage && progress === 30 && (
                <UserForm 
                    setSignupData={updateSignupData} 
                    setProgress={setProgress}
                    validationErrors={validationErrors}
                />
            )}
            {!error && !showMobileMessage && progress === 80 && (
                <PasswordForm
                    signupData={signupData}
                    setSignupData={updateSignupData} 
                    setProgress={setProgress}
                    validationErrors={validationErrors}
                />
            )}
            {!error && !showMobileMessage && progress === 100 && <Loading />}
            {!error && showMobileMessage && <MobileMessage />}
        </>
    );
};

export default Onboarding;
